import React from 'react';
import './Loading.css';
import {AiOutlineLoading3Quarters} from 'react-icons/ai';

const Loading = () => {
	return (
		<div>
			<AiOutlineLoading3Quarters className="loading-icon"/>
		</div>
	)
}

export default Loading